import { render } from "./right-sidebar.vue?vue&type=template&id=02fcd7fe&scoped=true&ts=true"
import script from "./right-sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./right-sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./right-sidebar.vue?vue&type=style&index=0&id=02fcd7fe&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fcd7fe"],['__file',"src/views/bookmark/components/right-sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02fcd7fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02fcd7fe', __exports__)) {
    console.log('reload')
    api.reload('02fcd7fe', __exports__)
  }
  
  module.hot.accept("./right-sidebar.vue?vue&type=template&id=02fcd7fe&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('02fcd7fe', render)
  })

}


export default __exports__